import React from 'react'

interface LoadingSpinnerBaseProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  isWhite?: boolean
  spinnerColor?: string
}

export const LoadingSpinnerBase: React.FC<LoadingSpinnerBaseProps> = ({
  size = 'md',
  className = '',
  isWhite = false,
  spinnerColor
}) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16'
  }

  return (
    <>
      <style>
        {`
          @keyframes spin {
            from { 
              transform: translate3d(0, 0, 0) rotate(0deg); 
            }
            to { 
              transform: translate3d(0, 0, 0) rotate(360deg); 
            }
          }
        `}
      </style>
      <div
        style={{
          borderWidth: '2px',
          borderStyle: 'solid',
          borderColor: isWhite ? '#FFFFFF' : spinnerColor || '#1470CC',
          borderTopColor: 'transparent',
          // Use transform3d to enable hardware acceleration
          transform: 'translate3d(0, 0, 0)',
          // Use will-change to hint the browser about the animation
          willChange: 'transform',
          // Use keyframes animation for better performance
          animation: 'spin 0.75s linear infinite'
        }}
        className={`${sizeClasses[size]} rounded-full ${className}`}
      ></div>
    </>
  )
}
